import { Button, Card, CardActions, CardContent } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PutHooks from "../../Api/PutHook";
import { useEffect } from "react";
import AlertComponent from "../../Components/AlertComponent";
import { LoadingButton } from "@mui/lab";
import ActionDialog from "../../Components/ActionDialog";
import Page from "../../Components/Page";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoanProfile from "./LoanProfile";
import { useSelector } from "react-redux";

const LoanRequestProfile = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const location = useLocation();
  const navigate = useNavigate();

  const [fixLoading, fixResponse, fixRequest] = PutHooks();
  const [cancelLoading, cancelResponse, cancelRequest] = PutHooks();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [loanRequest, setLoanRequest] = useState(location.state);

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchLoanRequest = () => {};

  const fixLoanRequest = async () => {
    try {
      let formData = {
        loan_request_id: loanRequest.id,
      };

      let props = {
        url: "loan_request",
        body: formData,
      };

      const fixResp = await fixRequest(props);

      if (fixResp && fixResp.status === 200 && fixResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: fixResp.data.StatusMessage,
        });
        navigate(-1);
      } else {
        const errorMessage =
          fixResp?.data?.StatusMessage ??
          fixResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const cancelLoan = async () => {
    try {
      let formData = {
        loan_request_id: loanRequest.id,
      };

      const cancelResp = await cancelRequest({
        url: "cancel_loan",
        body: formData,
      });

      if (
        cancelResp &&
        cancelResp.status === 200 &&
        cancelResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: cancelResp.data.StatusMessage,
        });
        navigate(-1);
      } else {
        const errorMessage =
          cancelResp?.data?.StatusMessage ??
          cancelResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  // useEffect(() => {
  //   if (
  //     cancelResponse &&
  //     cancelResponse.status === 200 &&
  //     cancelResponse.data.StatusCode === 0
  //   ) {
  //     setSnackbar({
  //       open: true,
  //       severity: "success",
  //       message: "Loan cancelled successfuly!",
  //     });

  //     setTimeout(() => {
  //       closeDialog();
  //     }, 1000);
  //   } else {
  //     const errorMessage =
  //       cancelResponse?.data?.StatusMessage ??
  //       cancelResponse?.data?.message ??
  //       "An unexpected error occurred. Please try again.";

  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: errorMessage,
  //     });
  //   }
  // }, [cancelResponse]);

  return (
    <Page
      title={`Loan request profile for ${loanRequest?.id}`}
      actions={
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={loggedInUser}
        data={loanRequest}
        onSuccess={fetchLoanRequest}
      />

      <Card>
        <CardActions
          sx={{
            my: "20px",
            mx: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {loanRequest?.active_status === "pending" && (
            <LoadingButton
              loading={cancelLoading}
              variant="contained"
              onClick={() => {
                cancelLoan();
              }}
            >
              Cancel loan
            </LoadingButton>
          )}

          <Button variant="contained">View guarantors</Button>

          <Button
            variant="contained"
            onClick={() => {
              openDialog("nominate_guarantor", "Nominate Guarantor Form");
            }}
          >
            Add guarantor
          </Button>

          {loggedInUser?.role === "admin" && (
            <Button
              variant="contained"
              style={{ marginLeft: 16, fontWeight: "bold" }}
              disabled={loanRequest.status === 1 ? false : true}
              onClick={() => {
                fixLoanRequest();
              }}
            >
              {fixLoading ? "Fixing..." : "Fix request"}
            </Button>
          )}
        </CardActions>

        <CardContent>
          <LoanProfile _data={loanRequest} user={loggedInUser} />
        </CardContent>
      </Card>
    </Page>
  );
};

export default LoanRequestProfile;
